import { defineComponent } from 'navigation-components/platform/models';
import { capabilities } from '../../../capabilities';
import { NOTIFICATIONS_FLOATING_COMPONENT } from '../../constants';
import { Channels } from '../constants';
import { getFloatingStyle, getPath, getQueryParams, onNewNotification, onPrimaryTabChange } from '../internal';
const NAVIGATION_FLOATING_IFRAME_ID = 'in-app-notifications-floating-iframe';
export const floatingNotificationsComponentDef = defineComponent(NOTIFICATIONS_FLOATING_COMPONENT, () => {
  return {
    name: NOTIFICATIONS_FLOATING_COMPONENT,
    path: getPath({
      channel: Channels.FLOATING
    }),
    queryParams: getQueryParams(),
    iframeProps: {
      id: NAVIGATION_FLOATING_IFRAME_ID,
      style: getFloatingStyle()
    },
    functions: Object.assign({}, onNewNotification, onPrimaryTabChange),
    scrolling: false,
    initiallyOpen: true,
    deferLoading: true,
    capabilities: [capabilities.RESTYLE_CAP.getName(), capabilities.NAVIGATE_TO_CAP.getName()]
  };
});